<template>
  <GbwapsLayout title="Download GB WhatsApp APK" :intro="pageIntro" :breadcrumb="breadcrumb">
    <div class="download-page">
      <div id="gbwhatsapp-apk" class="download-cta-block card text-center">
        <img
          :src="apkImage"
          alt="GB WhatsApp APK download icon"
          width="120"
          height="120"
          loading="eager"
          class="download-cta-icon"
        />
        <a href="#gbwhatsapp-apk" class="btn-primary btn-large download-cta-btn" @click.prevent="onDownloadClick">
          Download GB WhatsApp APK v{{ apk.version }}
        </a>
        <p class="download-cta-meta">
          File Size: {{ apk.size }} | Version: {{ apk.version }} | Android {{ apk.android }}
        </p>
        <p class="download-cta-hint">
          Match size and version before install. Need help? See
          <router-link to="/install-gbwhatsapp/">How to Install GB WhatsApp APK</router-link>.
        </p>
      </div>

      <section
        v-for="section in sections"
        :id="section.id"
        :key="section.id"
        class="page-section site-section"
      >
        <h2>{{ section.h2 }}</h2>
        <ContentBlocks :blocks="section.blocks" />

        <table v-if="section.id === 'file-info'" class="app-info-table">
          <tbody>
            <tr v-for="row in versionRows" :key="row.label">
              <td>{{ row.label }}</td>
              <td>{{ row.value }}</td>
            </tr>
          </tbody>
        </table>

        <table v-if="section.id === 'system-requirements'" class="app-info-table system-req-table">
          <thead>
            <tr>
              <th colspan="2">System Requirements</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in systemRows" :key="row.label">
              <td>{{ row.label }}</td>
              <td>{{ row.value }}</td>
            </tr>
          </tbody>
        </table>

        <div v-if="section.id === 'safety-notice'" class="warning-box">
          <strong>Safety notice:</strong>
          GB WhatsApp is a third-party mod. Always back up chats before installing or updating. GBWaps is not affiliated
          with WhatsApp or Meta Platforms, Inc.
        </div>
      </section>
    </div>
  </GbwapsLayout>
</template>

<script>
import '@/css/gbwaps/pages.css';
import GbwapsLayout from '@/layouts/GbwapsLayout.vue';
import ContentBlocks from '@/components/gbwaps/ContentBlocks.vue';
import { LOGO_URL } from '@/config/gbwaps';
import {
	DOWNLOAD_APK,
	VERSION_INFO_ROWS,
	SYSTEM_REQUIREMENT_ROWS,
	DOWNLOAD_SECTIONS,
} from '@/data/download-content';

export default {
	name: 'DownloadPage',
	components: { GbwapsLayout, ContentBlocks },
	data() {
		return {
			pageIntro:
				'Get GB WhatsApp APK v18.80 for Android with file details, system requirements, and a short safety checklist before you sideload.',
			breadcrumb: [{ name: 'Home', to: '/' }, { name: 'Download' }],
			apk: DOWNLOAD_APK,
			apkImage: LOGO_URL,
			versionRows: VERSION_INFO_ROWS,
			systemRows: SYSTEM_REQUIREMENT_ROWS,
			sections: DOWNLOAD_SECTIONS,
		};
	},
	methods: {
		onDownloadClick() {
			// 正式 APK URL 接入后替换；当前锚点便于 CTA 布局验收
			if (typeof window !== 'undefined') {
				const el = document.getElementById('gbwhatsapp-apk');
				if (el) el.scrollIntoView({ behavior: 'smooth' });
			}
		},
	},
};
</script>
